<div class="profile-header-card" *ngIf="(profileState | async).profileDetail !== null">
  <app-loader *ngIf="!(profileState | async).loader['audit']['followerEngage']" size="sm"></app-loader>

  <div class="profile-header" [class.dimmed]="!(profileState | async).loader['audit']['followerEngage']">
    <div class="profile-identity">
      <a class="avatar-wrapper" href="{{'https://www.tiktok.com/@' + (profileState | async).profileDetail.username}}" target="_blank">
        <img class="avatar-img"
             [src]="(profileState | async).profileDetail.avatar"
             onerror="this.onerror=null;this.src='./assets/images/icons/face.png'"
             alt="Audited profile avatar"/>
        <span class="platform-badge tiktok">
          <i class="bi bi-tiktok"></i>
        </span>
      </a>
      <div class="profile-meta">
        <h1 class="username">
          <a href="{{'https://www.tiktok.com/@' + (profileState | async).profileDetail.username}}" target="_blank">
            &#64;{{(profileState | async).profileDetail.username}}
          </a>
        </h1>
        <p class="fullname" *ngIf="(profileState | async).profileDetail.nickname">{{(profileState | async).profileDetail.nickname}}</p>
        <p class="generated-date" *ngIf="(profileState | async).audit !== null">
          <i class="bi bi-calendar3"></i>
          Generated on {{(profileState | async).audit.added_time * 1000 | date}}
        </p>
      </div>
    </div>

    <div class="key-stats">
      <div class="stat-box">
        <span class="stat-number">{{(profileState | async).profileDetail.video_count | shortcutNumbers}}</span>
        <span class="stat-label">Videos</span>
      </div>
      <div class="stat-box">
        <span class="stat-number">{{(profileState | async).profileDetail.follower_count | shortcutNumbers}}</span>
        <span class="stat-label">Followers</span>
      </div>
      <div class="stat-box">
        <span class="stat-number">{{(profileState | async).profileDetail.following_count | shortcutNumbers}}</span>
        <span class="stat-label">Following</span>
      </div>
      <div class="stat-box">
        <app-audit-no-mention type="value">
          <span class="stat-number" *ngIf="((profileState | async).audit !== null) && (profileState | async).followerEngage !== null">
            {{(profileState | async).followerEngage.engage_count | number:'1.2'}}%
          </span>
        </app-audit-no-mention>
        <span class="stat-label">
          ER
          <a data-tooltip="Percent of followers who liked or commented the post (last 30 days)">
            <i class="bi bi-info-circle"></i>
          </a>
        </span>
      </div>
    </div>
  </div>
</div>
